import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17c.cc',
  url: 'https://17c.cc',
  description: '17c.cc 是您不可错过的优质平台，提供官方入口、使用指南、功能介绍及常见问题解答',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://17c.cc/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const pageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '17c.cc 官方入口',
  description: '17c.cc 官方入口与核心功能全解析，提供使用指南、功能介绍及常见问题解答',
  isPartOf: {
    '@type': 'WebSite',
    name: '17c.cc',
    url: 'https://17c.cc',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="官方入口"
        description="17c.cc 是您不可错过的优质平台，本页详细介绍 17c.cc 的官方入口、核心功能、使用指南及常见问题，帮助用户快速上手 17c.cc，享受流畅便捷的体验。"
        keywords="17c.cc,17c.cc官方入口,17c.cc使用指南,17c.cc注册登录,17c.cc最新地址,17c.cc功能介绍,17c.cc常见问题"
        canonicalUrl="https://17c.cc/"
        structuredData={{ ...structuredData, ...pageStructuredData }}
      />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <LatestArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}